import Axios from "axios";

let pluginAxiosInstalled = false

// export default plugin;
export default {
	parseOptions(data){
		const options = {};
		if(data && data.wpConfig && data.wpConfig.wp_nonce) options.nonce = data.wpConfig.wp_nonce;
		if(data && data.wpConfig && data.wpConfig.wp_ajax_url){
			options.baseURL = data.wpConfig.wp_ajax_url;
			options.is_wordpress = true;
		}
		return options;
	},
	install(app, options){
		if(pluginAxiosInstalled) return;

		let baseURL = (options && options.baseURL) || import.meta.env.VITE_AJAX_BASE_URL || 'http://localhost:8001/'

		const axios = Axios.create({
			baseURL,
			headers: {
				common: {
					'x-requested-with': 'XMLHttpRequest'
				}
			}
		});

		if(options && options.is_wordpress){
			axios.interceptors.request.use((config) => {
				if(config.url.startsWith('trenitalia')){
					const requestedAction = config.url.replace(/^trenitalia(\/?)/, '');
					const originalMethod = config.method;
					config.url = '';
					config.method = 'post';
					const formData = new FormData();
					formData.append('action', 'trenitalia');
					formData.append('plugin_action', requestedAction);
					if(originalMethod == 'get' && config.params){
						formData.append('data', JSON.stringify(config.params));
						config.params = {};
					}
					if(config.data) formData.append('data', JSON.stringify(config.data));
					if(options && options.nonce) formData.append('_wpnonce', options.nonce);
					config.data = formData;
				}
				return config;
			});
		}

		if(app.config.globalProperties.$pinia){
			app.config.globalProperties.$pinia.use(() => ({$axios: axios}));
		}

		app.provide('axios', axios);
		app.config.globalProperties.$axios = axios;
		pluginAxiosInstalled = true;
	}
};